/**
 * This function is responsible for writing data with the given {@link key} to the local storage.
 */
export const writeSessionStorage = <T>(key: string, value: T): T => {
  const item = JSON.stringify(value);
  sessionStorage.setItem(key, item);
  return value;
};
